import { i18n } from '../../internationalize/i18n.service'

export class NumberFormatter {
    private numberPrefix = new Map<NumberType, string>([
        [NumberType.price, '$'],
        [NumberType.bitcoinPrice, '₿'],
        [NumberType.ethereumPrice, 'Ξ'],
        [NumberType.percent, '%'],
    ])

    private formatNumber(number: number): string {
        const absNumber = Math.abs(number);
        let minFractionDigits: number;
        let maxFractionDigits: number;

        if (absNumber >= 1) {
            minFractionDigits = 2;
            maxFractionDigits = 2;
        } else {
            const decimalPart = number.toString().split('.')[1];
            const firstNonZeroDecimalPosition = decimalPart ? decimalPart.search(/[1-9]/) : -1;
            
            if (firstNonZeroDecimalPosition >= 0) {
                minFractionDigits = firstNonZeroDecimalPosition + 3;
                maxFractionDigits = firstNonZeroDecimalPosition + 3;
            } else {
                // No non-zero digits found (edge case)
                minFractionDigits = 2;
                maxFractionDigits = 2;
            }
        }
        
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: minFractionDigits,
            maximumFractionDigits: maxFractionDigits,
            useGrouping: true
        }).format(number).replace(/,/g, ' ');
    }

    defaultFormat(number: number, type: NumberType | undefined = undefined): string {
        if (type === NumberType.percent) {
            return `${this.formatNumber(number)} %`;
        }
        const prefixString = type ? this.numberPrefix.get(type) || '' : '';
        const absNumber = Math.abs(number);

        const thresholds = [
            { value: 1e9, suffix: i18n.t('billions_separator') },
            { value: 1e6, suffix: i18n.t('millions_separator') },
            { value: 1e3, suffix: i18n.t('thousands_separator') }
        ];

        const match = thresholds.find(t => absNumber >= t.value);

        if (match) {
            const scaledNumber = absNumber / match.value;
            const formatted = this.formatNumber(scaledNumber);
            return `${prefixString + (number < 0 ? '-' : '')} ${formatted} ${match.suffix}`;
        } else {
            const formatted = this.formatNumber(absNumber);
            return `${prefixString + (number < 0 ? '-' : '')} ${formatted}`;
        }
    }

}

export enum NumberType {
    number = 'number',
    price = 'price',
    percent = 'percent',
    bitcoinPrice = 'bitcoinPrice',
    ethereumPrice = 'ethereumPrice',
}

export const numberFormatters = new NumberFormatter()